module.exports = __webpack_public_path__ + "img/confetti.6eedb2ec.gif";